import { apiRequest } from './client';

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  avatarUrl: string | null;
  activeRole: 'freelancer' | 'client';
  currency: string;
  timezone: string;
  dateFormat: string;
  weekStart: string;
  profiles: Array<{ role: string; title?: string; hourlyRate?: number; companyName?: string }>;
  freelancerProfile?: { title?: string; hourlyRate?: number; config?: Record<string, unknown> | null } | null;
  clientProfile?: { companyName?: string; config?: Record<string, unknown> | null } | null;
  hourlyRate?: number | null;
  freelancerConfig?: Record<string, unknown> | null;
  clientConfig?: Record<string, unknown> | null;
  notificationPrefs?: Record<string, boolean> | null;
  emailSettings?: {
    smtpHost: string;
    smtpPort: number;
    smtpUser: string;
    smtpPass: string;
    fromName: string;
    fromEmail: string;
  } | null;
}

export async function login(email: string, password: string) {
  const data = await apiRequest<{ accessToken: string; refreshToken: string; user: AuthUser }>('/auth/login', {
    method: 'POST',
    body:   JSON.stringify({ email, password }),
  });
  localStorage.setItem('tt-access-token',  data.accessToken);
  localStorage.setItem('tt-refresh-token', data.refreshToken);
  return data;
}

export async function signup(name: string, email: string, password: string, role: 'freelancer' | 'client') {
  return apiRequest('/auth/signup', {
    method: 'POST',
    body:   JSON.stringify({ name, email, password, role }),
  });
}

export async function logout() {
  const refreshToken = localStorage.getItem('tt-refresh-token');
  try {
    await apiRequest('/auth/logout', {
      method: 'POST',
      body: JSON.stringify({ refreshToken }),
    });
  } finally {
    localStorage.removeItem('tt-access-token');
    localStorage.removeItem('tt-refresh-token');
  }
}

export async function getMe(): Promise<AuthUser> {
  return apiRequest<AuthUser>('/users/me');
}

export async function updateMe(data: Partial<Pick<AuthUser, 'name' | 'currency' | 'timezone' | 'dateFormat' | 'weekStart'> & { title?: string; hourlyRate?: number; companyName?: string; avatarUrl?: string; notificationPrefs?: Record<string, boolean>; emailSettings?: AuthUser['emailSettings']; freelancerConfig?: Record<string, unknown>; clientConfig?: Record<string, unknown> }>) {
  return apiRequest('/users/me', { method: 'PATCH', body: JSON.stringify(data) });
}

export async function changePassword(currentPassword: string, newPassword: string) {
  return apiRequest('/users/me/change-password', {
    method: 'POST',
    body:   JSON.stringify({ currentPassword, newPassword, confirmNewPassword: newPassword }),
  });
}
